<template>
<!--    <img alt="Vue logo" width="200" height="200" src="./assets/img/footer.jpg">-->
  <!--  <HelloWorld msg="Welcome to Your Vue.js App"/>-->

<!--  <h1>App.vue</h1>-->
  <nav >
<!--    <RouterLink class="mr-2 border" to="/" v-if="$route.meta.showHeader">Go to Home</RouterLink>
    <RouterLink class="mr-2 border" to="/shop" v-if="$route.meta.showHeader">Shop</RouterLink>
    <RouterLink class="mr-2 border" to="/contact" v-if="$route.meta.showHeader">contact</RouterLink>-->


    <headerApp></headerApp>
  </nav>
  <main class="mt-5 pt-5 container">
    <RouterView />
  </main>

</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
import headerApp from './components/headerApp.vue'


// import ShopLine from "@/ShopLine.vue";

export default {
  name: 'App',
  components: {

    headerApp
  },
  data(){
    return {
      name:"hassan"
    }
  },
  provide(){
    return{
      mess:this.name
    }
  }


}
</script>

<style>
#app {
  /*font-family: Avenir, Helvetica, Arial, sans-serif;*/
  /*-webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;*/
}
#nprogress .bar {
 /* background: #42b983 !important; !* رنگ دلخواه *!*/
  background: #ff0000 !important; /* رنگ دلخواه */
}

img[alt]:after {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  color: transparent;
  text-align: center;
  content: attr(alt);
  background: #fff url(./assets/img/image-placeholder.svg) no-repeat 50%;
  background-size: contain;
  width: 100%;
  height: 100%;
}
</style>
